import styled, { css } from 'styled-components';
import theme from 'styled-theming';
import breakpoint, { getZindexByType } from '~/utils/style-utils';
import { fixedCasinoTop } from '~/utils/layout-utils';

const secondaryFiltersBrandException = theme('brand', {
	mobilebet: css`
		background-color: transparent;
		${breakpoint.lg`
			background-color: var(--filter-bg-secondary);
		`}
		background-color: transparent;
	`
});

const FiltersContainer = styled.div<{ secondary?: boolean; hasStaticHeader: boolean; isTablet?: boolean }>`
	padding: 0;
	display: flex;
	align-items: center;
	max-width: 100%;
	height: var(--casino-navbar-height--mobile);
	overflow: auto;
	${props =>
		props.secondary &&
		css`
			--filter-active: var(--filter-active-secondary);
			--filter-idle: var(--filter-idle-secondary);
			--filter-hover: var(--filter-hover-secondary);
			--filter-bar-active: var(--filter-bar-active-secondary);
			${secondaryFiltersBrandException}
		`};

	${props => breakpoint.lg`
			background-color: var(--submenu-bg--desktop);
			height: var(--casino-navbar-height--desktop);
			padding: 0 var(--biggerFrame);
			border-bottom: 1px solid var(--filter-border-secondary, rgba(var(--base-09), 1));
			position: sticky;
			top: ${fixedCasinoTop(props)};
			z-index: ${getZindexByType('casino-nav')};
			${props.isTablet && 'width: 100vw;'};
	`}
`;

interface FiltersInnerProps {
	dataAt: string;
	hideLeftShadow?: boolean;
	hideRightShadow?: boolean;
	alignnavright?: boolean;
}

const dataAt = (props: FiltersInnerProps) => ({
	'data-at': props.dataAt
});

const FiltersInner = styled.nav.attrs<FiltersInnerProps, FiltersInnerProps & { 'data-at': string }>(dataAt)`
	display: flex;
	flex: 1 1 0;
	align-items: center;
	max-width: 100%;
	overflow: hidden;
	min-width: 0;

	mask-image: ${({ hideLeftShadow, hideRightShadow }) => {
		if (!hideLeftShadow && !hideRightShadow) {
			return 'linear-gradient(90deg, transparent 4px, black 40px, black calc(100% - 40px), transparent calc(100% - 4px))';
		}
		if (hideLeftShadow) {
			return 'linear-gradient(to left, transparent 4px, black 40px)';
		}
		if (hideRightShadow) {
			return 'linear-gradient(to right, transparent 4px, black 40px)';
		}

		return '';
	}};

	${props => (props.alignnavright ? 'justify-self: end;' : '')};

	${breakpoint.lg`
    margin-right: 12px;
  `};
`;

export { FiltersContainer, FiltersInner };
